<template>
  <div>
    <form class="form" @submit.prevent="updateQuery">
      <input v-model="inputQuery" type="text" id="findProvider" class="form-control form__input"
             placeholder="Search for a provider's name, specialty or keyword"/>
      <button class="form__button" type="submit">Search providers</button>
    </form>

    <p>Search results for "{{ inputQueryCopy }}"</p>

    <template v-if="providers.length !== 0">
      <search-provider-results :providers="providers" :keywords="keywords"></search-provider-results>
    </template>

    <template v-else>
      <h2>Sorry, we couldn't find anything for "{{ inputQueryCopy }}"</h2>
    </template>
  </div>
</template>

<script>
  import SearchProviderResults from './SearchProviderResults';
  import {mapGetters} from 'vuex';
  import {getProviderByNpi} from '@/api/getters/provider';

  export default {
    name: "SearchProvider",
    components: {
      'search-provider-results': SearchProviderResults,
    },
    data() {
      return {
        providers: [],
        inputQuery: '',
        inputQueryCopy: '',   // required. can't use `inputQuery` in the else block because it is reactive',
        keywords: [],
      }
    },
    beforeMount() {
      this.inputQuery = this.$route.query.query;
      this.searchProvider(this.$route.query.query);
    },
    computed: {
      ...mapGetters('login', {
        providersFromStore: 'getProviders',
        allData: 'getAllData',
      }),
    },
    methods: {
      searchProvider() {
        this.providers = [];
        this.inputQueryCopy = this.inputQuery;

        // break down user input to an array of strings, split by white spaces
        this.keywords = stringToArray(this.inputQuery);
        let regexp = new RegExp(this.keywords.join("|"), "i");

        let provider = {};
        Object.keys(this.providersFromStore).forEach(key => {
          provider = getProviderByNpi(this.allData, key);

          // test first name, middle name, last name, specialties, and ???
          // todo test all specialties
          if (regexp.test(provider.firstName) || regexp.test(provider.lastName)
              || regexp.test(provider.middleName)
              || regexp.test(provider.specialties[0].name)) {
            this.providers.push(provider);
          }
        });

      },

      updateQuery() {
        // not redirect, just replace the string
        this.$router.replace({path: 'search', query: {category: 'provider', query: this.inputQuery}});
        this.searchProvider();
      },

    }
  }

  let stringToArray = string => {
    return string.split(/(\s+)/).filter(e => {
      return e.trim().length > 0;
    });
  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/mixins/flex";

  $color-base: #0060ff;
  $color-font: #58595b;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  button {
    border: none;
    cursor: pointer;
    background-color: #2196F3;
    color: #fff;
    padding: 5px 10px;
    font-size: 14px;
  }

  button:hover {
    background-color: #0060ff;
  }

  h2 {
    font-size: 1.5em;
    color: $color-font;
    margin-top: 2.0em;
    text-align: center;
  }

  p {
    margin-top: 1.0em;
    font-size: 0.85em;
  }


  .list {
    margin: 0 auto;
  }

  .form-control {
    font-size: 0.85em;
  }

  .form {
    @include flex-box();
    @include flex-wrap(wrap);

    .form__input {
      @include flex(1, 0, 70%);
    }

    .form__button {
      @include flex(1, 0, 20%);
    }
  }

</style>